import * as Mui from "@mui/material";
import { useContext, useEffect, useState } from "react";

import { AxiosError } from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import OperationTypes from "../../types";
import VehicleEntranceService from "./service/VehicleEntranceService";

const VehicleEntranceCheckList = () => {
  const { setLoading, userLocations } = useContext(ContextOperation);

  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const location = useLocation();
  const t = useOperationTranslation();
  const vehicleData: any = location.state;

  const [checkList, setCheckList] = useState<
    { id: number; name: string; tenant: string }[]
  >([]);
  const [checkedItem, setCheckedItem] = useState<any>({});

  useEffect(() => {
    if (!vehicleData) {
      navigate("/operation/transfer/vehiclesEntrance");
    } else {
      VehicleEntranceService.get
        .checkList(vehicleData.tenant, vehicleData.enginePowerCode ?? null)
        .then((response) => setCheckList(response));
    }
  }, []);

  const handleCheck = (index: number) => {
    let copyCheckedItemList: any = checkedItem;

    if (copyCheckedItemList[index]) {
      delete copyCheckedItemList[index];
    } else {
      copyCheckedItemList[index] = true;
    }

    setCheckedItem(copyCheckedItemList);
  };

  const submit = () => {
    const { plate, entranceLocationId } = vehicleData;

    //LE userLocation tornate non sembrano avere quelle di Francia
    //console.log('VehicleEntranceCheckList vehicleData: ', vehicleData);
    //console.log('VehicleEntranceCheckList with userLocations: ', userLocations);
    //console.log('VehicleEntranceCheckList with plate: ', plate);
    console.log('VehicleEntranceCheckList with entranceLocationId: ', entranceLocationId);
    
    //Esempio dei valori visti da log per la fix 94 ( primo inflottamento)
    //entranceLocationId = Actemium France (DMS)    //causa del ticket, adesso sembra tornare correttamente la key (1184066598-LMS)
    //vehicleData.allLocations.value = 1184066598-LMS
    //vehicleData.allLocations.label = Actemium France (DMS)
    //vehicleData.allLocations.bpCode = 1184066598
    
    //userLocations.key = 1184066598-LMS
    //userLocations.id = 1184066598
    //userLocations.bpCode = 1184066598


    //OLD
    //const entranceLocation = vehicleData.allLocations.find((item: any) => item.value === entranceLocationId).bpCode;
    //const entranceStationType = userLocations.find(loc => entranceLocationId === loc.key)?.typeEnum;



    //Le location francesi non erano presenti, usato lo stesso codice previsto per VehicleEntrancePlateMigration
    const entranceLocation = entranceLocationId.split('-')[0];
    const entranceStationType = entranceLocationId.split('-')[1];


    console.log('VehicleEntranceCheckList with entranceLocation: ', entranceLocation);
    console.log('VehicleEntranceCheckList with entranceStationType: ', entranceStationType);



    setLoading(true);
    VehicleEntranceService.add
      .vehicleFirstCheckin(vehicleData.tenant, {
        plate: plate,
        entranceStationId: entranceLocation,
        entranceStationType: entranceStationType,
        km: vehicleData.km,
        checkList: checkList.map((item: any, index: number) => {
          return { id: item.id, checked: Boolean(checkedItem[index]) };
        }),
        fuelLevel: vehicleData.fuelLevel,
        batteryLevel: vehicleData.batteryLevel,
        carTransporterExternalDeliveryNoteNumber: vehicleData.carTransporterExternalDeliveryNoteNumber,
        carTransporterUnloadingDate: vehicleData.carTransporterUnloadingDate,
      })
      .then(
        () => {
          setLoading(false);
          snackbar.show("success", t("vehicleEntrance.search.success"));
          navigate(`/operation/transfer/vehiclesEntrance`);
        },
        (reject: AxiosError<OperationTypes.AxiosErrorResponse>) => {
          setLoading(false);
          if(reject.response?.status === 400) {
            snackbar.show("error", t("vehicleEntrance.search.errors.400Error"))
          }
          else if (reject.response?.status === 404) {
            snackbar.show("error", t("vehicleEntrance.search.errors.404Error"))
          }
          else if (reject.response?.status === 409) {
            snackbar.show("error", t("vehicleEntrance.search.errors.409Error"))
          }
          else {
            snackbar.show("error", t("vehicleEntrance.search.errors.500Error"))
          }
        }
      );
  };

  return (
    <Mui.Box
      sx={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        pb: 5,
        mt: 4,
      }}
    >
      <Mui.Card>
        <Mui.Typography variant="h4" textAlign={"center"} mt={4}>
          {t("vehicleEntrance.confirm.checkList")}
        </Mui.Typography>
        {checkList.map((item, index: number) => {
          return (
            <Mui.CardContent
              key={item.id}
              sx={{
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <Mui.Checkbox
                color={"accent"}
                size="medium"
                checked={checkedItem[index]}
                onClick={() => handleCheck(index)}
              />

              <Mui.Typography variant="body2" mt={1}>
                {item.name}
              </Mui.Typography>
            </Mui.CardContent>
          );
        })}

        <Mui.Button
          variant="contained"
          onClick={() => submit()}
          fullWidth
          sx={{ mt: 2 }}
        >
          {t("vehicleEntrance.confirm.confirmStatus")}
        </Mui.Button>
      </Mui.Card>
    </Mui.Box>
  );
};
export default VehicleEntranceCheckList;
